import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";
import CreateCompetenceReportModal from "./CreateCompetenceReportModal";
import RoundedCard from "../../../components/RoundedCard/RoundedCard";
import { ReportType } from "../../../store/types/report";
import { ClockIcon, MoonIcon } from "../../../assets/imgs";
import { Colors } from "../../../utils/constants/style";
import CreateConsolidatedPaymentHoursModal from "./CreateConsolidatedPaymentHoursModal";
import CreateExtraHoursModal from "./CreateExtraHoursModal";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";

const ConsolidatedReports: React.FC<{}> = () => {
  const { pushModal } = useModal();
  const openCompetenceReportModal = (label: string) => pushModal(<CreateCompetenceReportModal label={label} />);
  const openConsolidatedPaymentHoursModal = () => pushModal(<CreateConsolidatedPaymentHoursModal />);
  const openExtraHoursModal = () => pushModal(<CreateExtraHoursModal />);
  const setReportType = useStore((state) => state.report.setReportType);
  const adminData = useStore((state) => state.admin.data);

  return (
    <div className="mt-4">
      <ShadowBox>
        <div>
          <span className="text-lg font-bold text-dark-blue">Clique para fazer download do relatório desejado</span>
          <div className="flex flex-wrap gap-10 mt-10 mb-5">
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.CREATE_CONSOLIDATED_REST_TIME_REPORT)
                openCompetenceReportModal("Relatório de folgas")
              }}
              icon={<MoonIcon width={32} height={32} color={Colors.white}/>}
              title="Folgas"
              text="Lista de folgas por período selecionado"
            />
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.CREATE_CONSOLIDATED_PAYMENT_HOURS_REPORT)
                openConsolidatedPaymentHoursModal()
              }}
              icon={<ClockIcon width={24} height={24} color={Colors.white}/>}
              title="Horas Consolidadas"
              text="Pagamentos de horas consolidadas"
            />
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.CREATE_CONSOLIDATED_EXTRA_HOURS_REPORT)
                openExtraHoursModal()
              }}
              icon={<ClockIcon width={24} height={24} color={Colors.white}/>}
              title="Horas Extras"
              text="Horas extras para um determinado período"
            />
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.CREATE_REST_DRIVING_CONTROL_REPORT)  
                openCompetenceReportModal("Relatório de controle de descanso e direção")
              }}
              icon={<ClockIcon width={24} height={24} color={Colors.white}/>}
              title="Descanso e direção"
              text="Verifique o descanso dos colaboradores dentro de um período"
            />
            
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default ConsolidatedReports;
